// extracted by mini-css-extract-plugin
export default {"date":"DateToday_date__igEIg"};